import { useEffect, useRef } from 'react';

function DualScrollTable({ children }) {
  const topScrollRef = useRef(null);
  const tableWrapperRef = useRef(null);

  useEffect(() => {
    const topScroll = topScrollRef.current;
    const tableWrapper = tableWrapperRef.current;

    if (!topScroll || !tableWrapper) return;

    const syncWidth = () => {
      const table = tableWrapper.querySelector('.grid-table');
      if (table) {
        const width = table.offsetWidth;
        if (topScroll.firstChild) {
          topScroll.firstChild.style.width = width + 'px';
        }
      }
    };

    const handleTopScroll = () => {
      tableWrapper.scrollLeft = topScroll.scrollLeft;
    };

    const handleBottomScroll = () => {
      topScroll.scrollLeft = tableWrapper.scrollLeft;
    };

    syncWidth();
    setTimeout(syncWidth, 50);
    setTimeout(syncWidth, 200);
    setTimeout(syncWidth, 500);

    topScroll.addEventListener('scroll', handleTopScroll);
    tableWrapper.addEventListener('scroll', handleBottomScroll);
    window.addEventListener('resize', syncWidth);

    const resizeObserver = new ResizeObserver(syncWidth);
    resizeObserver.observe(tableWrapper);

    return () => {
      topScroll.removeEventListener('scroll', handleTopScroll);
      tableWrapper.removeEventListener('scroll', handleBottomScroll);
      window.removeEventListener('resize', syncWidth);
      resizeObserver.disconnect();
    };
  }, [children]);

  return (
    <div className="dual-scroll-container">
      {/* 상단 스크롤바 - 모든 스타일은 CSS에서 */}
      <div ref={topScrollRef} className="top-scroll">
        <div className="top-scroll-inner" />
      </div>

      {/* 테이블 영역 - 모든 스타일은 CSS에서 */}
      <div ref={tableWrapperRef} className="grid-table-wrapper">
        {children}
      </div>
    </div>
  );
}

export default DualScrollTable;